import React from 'react';
import { motion } from 'framer-motion';
import { PlaneTakeoff, CheckCircle } from 'lucide-react';
import PageHero from '../components/PageHero';
import CTASection from '../components/CTASection';
import SEO from '../components/SEO';

const AircraftCharter = () => {
  const services = [
    'Full and part aircraft charter',
    'Urgent aircraft-part movements',
    'Oversized and specialist cargo',
    'Route feasibility assessment',
    'Airport and ground-handling coordination',
    'End-to-end charter management',
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Urgent Aircraft Charter | Aero Time Critical"
        description="Full and part aircraft charter for urgent, oversized and specialist cargo. Route feasibility, ground-handling coordination and end-to-end charter management."
        path="/aircraft-charter"
      />
      <PageHero
        badge="DEDICATED AIRCRAFT"
        BadgeIcon={PlaneTakeoff}
        title="Aircraft"
        titleAccent="Charter"
        description="When scheduled services cannot meet the deadline, we arrange dedicated aircraft charter to any airport worldwide with flexible scheduling and maximum payload capacity."
        image="https://customer-assets-m6fa6gv7.emergentagent.net/job_cargo-urgent/artifacts/yvvhjwei_Air%20Charter.jpeg"
      />

      <section className="bg-[#F7F9FB] py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <img
                src="https://customer-assets-m6fa6gv7.emergentagent.net/job_cargo-urgent/artifacts/yvvhjwei_Air%20Charter.jpeg"
                alt="Cargo aircraft charter loading oversized freight"
                className="w-full h-[450px] object-cover rounded-lg shadow-xl"
                loading="lazy"
              />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
            >
              <span className="text-[#0089D0] font-semibold tracking-wide uppercase text-sm">Complete Charter Solutions</span>
              <h2 className="text-3xl md:text-4xl font-bold mt-3 mb-8 text-[#003057]">
                Dedicated Capacity, End to End
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {services.map((service, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: 20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.05 }}
                    className="flex items-center gap-3"
                  >
                    <CheckCircle className="text-[#0089D0] flex-shrink-0" size={22} />
                    <span className="text-[#003057] font-medium">{service}</span>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      <CTASection
        title="Need Dedicated Air Charter?"
        description="Contact our charter team for a rapid route feasibility assessment"
        buttonText="Request Charter Quote"
      />
    </div>
  );
};

export default AircraftCharter;
